(function ($) {
  /**
   * Check if component alert sticky is activated
   */

  const $stickyAlert = $(".c-alert-sticky");
  $(function () {
    setTimeout(function () {
      $stickyAlert.addClass("activated");
    }, 1500);
    /**
     * Hide Alert Sticky when user clicks close icon
     */
    $(".c-alert-sticky__close-alert").on("click", function () {
      $.ajax({
        url: core_params.ajaxurl,
        data: {
          action: "set_alert_cookie",
        },
        type: "POST",
        beforeSend: function () {
          $(".c-alert-sticky").removeClass("activated");
        },
      });
    });
  });
})(jQuery);
